import { ClickEventComponentNames, logButtonClick } from 'state/amplitude';

export const logConfirmationDialogCta = (name: string) => {
  logButtonClick({
    attributes: {
      component: ClickEventComponentNames.PRODUCT_DETAIL_CLOSE_ACTION_CTA,
      name,
    },
  });
};
